import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';

type ClassNameFunction<T = Record<string, unknown>> = (props: T) => ClassValue;

/**
 * Merges multiple `classNames`, handling both string and function arguments. Functions are called with the provided render props.
 *
 * @param classNames - Array of classNames (strings or functions)
 * @param renderProps - Props to pass to className functions
 * @returns Merged className string
 */
export const mergeClassNames = <T = Record<string, unknown>>(
  classNames: (ClassNameFunction<T> | ClassValue)[],
  props?: T
): string => {
  const transformedClassNames = [];

  for (const className of classNames) {
    if (typeof className === 'function') {
      transformedClassNames.push(className(props as T));
    } else {
      transformedClassNames.push(className);
    }
  }

  return clsx(transformedClassNames);
};
